export const isPublished = (publicationDate: string | undefined | null) => {
  if (!publicationDate) return false;

  const currentTime = new Date().getTime();
  const publicationTime = new Date(publicationDate).getTime();

  return publicationTime <= currentTime;
};
